












import { HistorySection } from '@/lib/domain/history-section';
import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
  computed: {
    ...mapGetters({
      sections: 'sections'
    })
  }
})
export default class Menu extends Vue {
  public ActiveItem = 'none';
  public sections!: HistorySection[];

  mounted(): void {
    this.ActiveItem = this.sections[0].Id;
    window.addEventListener('scroll', this.scrollStateChanged);
  }

  scrollStateChanged(): void {
    let currentElement;
    let currentId = this.ActiveItem;

    for (let section of this.sections) {
      let element = document.querySelector('#' + section.Id);
      if (element) {
        let bounding = element.getBoundingClientRect();
        
        if (currentElement != null) {
          currentElement = currentElement.top > bounding.top ? currentElement : bounding;
        } else {
          currentElement = bounding;
        }

        if (bounding == currentElement) {
          currentId = section.Id;
        }
      }
    }
    this.ActiveItem = currentId;
  }
}
